import React, { useMemo, useState, useEffect } from 'react';
import { DeckList } from '@/components/shared/DeckList';
import { useGetStructureId } from '@/hooks/useGetStructureId';
import { Deck } from '@/components/shared/DeckList/DeckList';
import { useAtomValue } from 'jotai';
import * as analysisState from '@/components/Analysis/state';
import {
  AssembliesDecksSummaryQuery,
  useAssembliesDecksSummaryLazyQuery,
  DeckAreaSummary,
} from '@/__generated__/graphql';

export const DeckListType = () => {
  const [previousDeck, setPreviousDeck] = useState<Deck | null>();
  const [loading, setLoading] = useState(false);
  const structureId = useGetStructureId();
  const applyFilters = useAtomValue(analysisState.applyFilters);
  const selectedTemplateFilters = useAtomValue(analysisState.selectedTemplateFiltersState);
  const templateId = useAtomValue(analysisState.selectedAssemblyTemplateId)!;
  const selectedDeckIds = useAtomValue(analysisState.selectedFilteredDeckIds);
  const selectedPaintRegionIds = useAtomValue(analysisState.selectedFilteredPaintRegionIds);
  const [appliedTemplateFilters, setAppliedTemplateFilters] = useState(selectedTemplateFilters);
  const [appliedDeckFilters, setAppliedDeckFilters] = useState(selectedDeckIds);
  const [appliedPaintRegionFilters, setAppliedPaintRegionFilters] =
    useState(selectedPaintRegionIds);
  const [filteredDecks, setFilteredDecks] = useState<AssembliesDecksSummaryQuery | undefined>();

  const [fetchAssembliesDecksSummary] = useAssembliesDecksSummaryLazyQuery();

  useEffect(() => {
    if (templateId && selectedTemplateFilters) {
      setLoading(true);
      fetchAssembliesDecksSummary({
        variables: {
          input: {
            structureId,
            selectedTemplateFilters: appliedTemplateFilters,
            templateId,
            selectedDeckIds: appliedDeckFilters,
            selectedPaintRegionIds: appliedPaintRegionFilters,
          },
        },
        fetchPolicy: 'network-only',
      }).then(({ data: filteredDecksData }) => {
        setFilteredDecks(filteredDecksData);
        setLoading(false);
      });
    }
  }, [
    appliedDeckFilters,
    appliedPaintRegionFilters,
    appliedTemplateFilters,

 
    fetchAssembliesDecksSummary,
    selectedTemplateFilters,
    structureId,
    templateId,
  ]);

  useEffect(() => {
    if (applyFilters) {
      setAppliedTemplateFilters(selectedTemplateFilters);
      setAppliedDeckFilters(selectedDeckIds);
      setAppliedPaintRegionFilters(selectedPaintRegionIds);
    }
  }, [applyFilters, selectedDeckIds, selectedPaintRegionIds, selectedTemplateFilters]);

  const handleChangeDeck = (selectedDeck: Deck) => {
    setPreviousDeck(selectedDeck);
  };

  const filteredAssemblyDecks = useMemo(() => {
    return filteredDecks?.getAssembliesDecksSummary || [];
  }, [filteredDecks?.getAssembliesDecksSummary]);

  return (
    <DeckList
      loading={loading}
      handleSelection={handleChangeDeck}
      handleSetLoading={setLoading}
      previousDeck={previousDeck}
      filteredAssemblyDecks={filteredAssemblyDecks as DeckAreaSummary[]}
    />
  );
};
